export const PropertyTypes = {
    SINGLE_LET: { id: 'singlE_LET', display: "Single Let" },
    HMO: { id: 'hmo', display: "HMO" }
}